import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Body } from '../../Layouts/Body'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { appApi } from '../../../services/appApi'
import { Main } from './styles'
import { Flex, FormControl, Text, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { InputCmp } from '../../../components/InputCmp'
import { InfoTooltipCmp } from '../../../components/InfoTooltipCmp'
import { TextAreaCmp } from '../../../components/TextareaCmp'
import { CheckboxCmp } from '../../../components/CheckboxCmp'
import { TimelineFeedback } from '../Timeline'

interface iFeedbackInput {
  nome: string
  modeloPadrao: boolean
  participanteVisualizarEntrada: boolean
  descricao?: string
}

export const CriarFeedback: React.FC = () => {
  const nav = useNavigate()
  const { pathname } = useLocation()
  const toast = useToast()

  const [Feedback, setFeedback] = useState<iFeedbackInput>({
    nome: '',
    modeloPadrao: false,
    participanteVisualizarEntrada: false
  })

  const [isValid, setisValid] = useState(true)

  function criarFeedback(): void {
    setisValid(true)

    if (Feedback.nome.length < 5) {
      setisValid(false)
      toast({
        title: 'O nome do feedback deve conter no mínimo 5 caracteres',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    appApi.post('FeedbackPersonalizado', Feedback)
      .then(response => {
        nav(pathname.replace('Criar', `${response.data}/Entrada`))
      }).catch(({ response }) => {
        console.log(response)
        toast({
          title: 'Erro',
          status: 'error',
          position: 'top-right',
          isClosable: false
        })
      }).finally(() => {
        toast({
          title: 'Feedback criado com sucesso',
          status: 'success',
          position: 'top-right',
          isClosable: false
        })
      })
  }

  return (
    <Body>
      <TimelineFeedback id={''}/>
      <Main>
        <h1>Criar feedback</h1>
        <Flex flexDir={'column'} gap={'1.25rem'}>

          <WhiteContainer>
            <Flex flexDir={'column'} gap={'1rem'} mb={'.5rem'}>
              <FormControl isInvalid={!isValid}>
                <Flex gap={'.325rem'} alignItems={'center'}>
                  <h3>Nome</h3>
                  <InfoTooltipCmp VarColor='Green2' label='Coloque o título do feedback, ele deve conter pelo menos 5 caractéres'/>
                </Flex>
                <InputCmp
                  mt={'.5rem'}
                  value={Feedback.nome}
                  OnChange={(e) => setFeedback({ ...Feedback, nome: e })}
                />
              </FormControl>
              <FormControl isInvalid={!isValid}>
                <Flex gap={'.325rem'} alignItems={'center'}>
                  <h3>Descrição</h3>
                </Flex>
                <TextAreaCmp
                  mt={'.5rem'}
                  value={Feedback.descricao}
                  OnChange={(e) => setFeedback({ ...Feedback, descricao: e })}
                />
              </FormControl>
              <CheckboxCmp isChecked={Feedback.participanteVisualizarEntrada} OnChange={(e) => setFeedback({ ...Feedback, participanteVisualizarEntrada: e })}>
                <Text fontSize={'14px'} fontWeight={'600'}>
                  Permitir que o participante (quem recebe o feedback) veja as informações previamente disponíveis (feedbacks anteriores, formulários, pesquisas...)
                </Text>
              </CheckboxCmp>
              <Flex flexDir={'column'} gap={'.25rem'}>
                <CheckboxCmp OnChange={(e) => setFeedback({ ...Feedback, modeloPadrao: e })}>
                  <Flex flexDir={'column'}>
                    <Text fontSize={'14px'} fontWeight={'600'}>
                      Criar um novo feedback com base no modelo padrão da Arquitetura Humana (Campos e etapas predefinidas)
                    </Text>
                  </Flex>
                </CheckboxCmp>
                <Text fontSize={'12px'} fontWeight={'400'} color={'var(--Gray3)'}>
                  Utiliza uma pré-seleção nossa dos itens para utilizar no seu feedback. Podendo realizar todas as alterações de acordo com sua necessidade.
                </Text>
              </Flex>
            </Flex>
          </WhiteContainer>
        </Flex>

        <Flex justifyContent={'end'} marginTop='1rem' gap={'.5rem'}>
          <ButtonCmp
            VarColor={'c6'}
            onClick={() => nav(-1)}
          >Voltar</ButtonCmp>
          <ButtonCmp
            onClick={criarFeedback}
            VarColor='Green2'
          >Criar feedback</ButtonCmp>
        </Flex>
      </Main>
    </Body>
  )
}
